export default __webpack_public_path__ + "static/media/alert-info.bbf74bf5.svg";